import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "memberCenter-record_primary",
  "use": "memberCenter-record_primary-usage",
  "viewBox": "0 0 100 220",
  "content": "<symbol viewBox=\"0 0 100 220\" xmlns=\"http://www.w3.org/2000/svg\" id=\"memberCenter-record_primary\"><path d=\"M0 21H100V46C100 49.3137 97.3137 52 94 52H0V21Z\" /><rect x=\"19\" y=\"57\" width=\"12\" height=\"5\" rx=\"2.5\" /><rect y=\"66\" width=\"50\" height=\"1\" /><path d=\"M0 204C0 201.791 1.79086 200 4 200H96C98.2091 200 100 201.791 100 204V220H0V204Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol